/**
 * @file study
 * @author 丁聪
 */

import React, { Component } from "react";
import "./index.scss";
import "./index.scss";

class Study extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    let introlist = [
      {
        img: require("@/images/home/f5-icon-ydy.png"),
        title: "一对一课堂",
        intro:
          "根据你的学习需求，进行针对性指导，和老师一对一实时互动，享受VIP专属教学服务，短期快速突破。",
      },
      {
        img: require("@/images/home/f5-icon-jx.png"),
        title: "精选小班课（≤4人）",
        intro:
          "匹配中文水平相近的小伙伴，利用同伴学习场景，建立浓厚的学习氛围，借助“榜样”力量，激发潜能，共同进步。",
      },
      {
        img: require("@/images/home/f5-icon-ss.png"),
        title: "Mini大班课（≤18人）",
        intro:
          "模拟线下班级，利用竞争学习环境，调动孩子学习积极性，课后社群服务高效省事，节省学习成本。",
      },
    ];
    return (
      <div id="course-study">
        <div className="inner-title">课堂形式</div>
        <div className="study-inner">
          <ul className="intro">
            {introlist.map((item, index) => (
              <li key={"intro-" + index}>
                <div
                  className="img"
                  style={{
                    background: `url(${item.img}) no-repeat center top`,
                  }}
                ></div>
                <div className="title">{item.title}</div>
                <div className="intro">{item.intro}</div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

export default Study;
